// extracted by mini-css-extract-plugin
export default {"brandPromo":"bG-z","carousel":"cG-z"};